export default {
    name: ["HPC Admin Back-Office", "ប្រព័ន្ធគ្រប់គ្រងថ្នាលអង្គគណនាពពកកម្រឹតខ្អស់"],
    headTitle: ["HPC Admin Back-Office", "ប្រព័ន្ធគ្រប់គ្រងថ្នាលអង្គគណនាពពកកម្រឹតខ្អស់"],
    system: ["Ministry of Industry, Science, Technology & Innovation", "ក្រសួងឧស្សាហកម្ម វិទ្យាសាស្រ្ត បច្ចេកវិទ្យា និងនវានុវត្តន៍"],
    gdind: ["General Department of Industry", "អគ្គនាយកដ្ឋានឧស្សាហកម្ម"],
    logout: ["Log Out", "ចាកចេញ"],
    startDate: ["Start Date", "ថ្ងៃចាប់ផ្តើម"],
    endDate: ["End Date", "ថ្ងៃបញ្ចប់"],
    active: ["Active", "ដំណើរការ"],
    showMore: ["Show more", "បង្ហាញបន្ថែម"],
    search: ["Search", "ស្វែងរក"],
    edit: ["Edit", "កែប្រែ"],
    enable: ["Enable", "ដាក់ដំណើរការ"],
    disable: ["Disable", "បញ្ចប់ដំណើរការ"],
    delete: ["Delete", "លុបចេញ"],
    cancel: ["Cancel", "បោះបង់"],
    confirm: ["Confirm", "យល់ព្រម"],
    statusAll: ["Status (All)", "ស្ថានភាព (ទាំងអស់)"],
    typeAll: ["Type (All)", "ប្រភេទ (ទាំងអស់)"],
    type: ["Type", "ប្រភេទ"],
    update: ["Update", "ធ្វើបច្ចុប្បន្នភាព"],
    all: ["All", "ទាំងអស់"],
    status: ["Status", "ស្ថានភាព"],
    action: ["Action", "សកម្មភាព"],
    code: ["Code", "លេខកូដ"],
    home: ["Home", "ទំព័រដើម"],
    day: ["days", "ថ្ងៃ"],
    goHome: ["Go Home", "ទៅកាន់ទំព័រដើម"],
    editMore: ["Edit", "បំពេញបន្ថែម"],
    no: ["No.", "ល.រ."],
    identity: ["Identification", "លេខអត្តសញ្ញាណ"],
    company: ["Legal/Physical Person", "នីតិបុគ្គល / រូបវន្តបុគ្គល"],
    service: ["Public Service", "សេវាសាធារណៈ"],
    login: ["Login to the System", "ចូលទៅកាន់ប្រព័ន្ធ"],
    download: ["Download", "ទាញយក"],
    loading: ["Loading", "កំពុងផ្ទុក"],
    upload: ["Upload", "ផ្ទុកឯកសារ"],
    viewMore: ["VIEW", "មើលបន្ថែម"],
    applicationCode: ["Form Code", "លេខកូដពាក្យស្នើ"],
    applicant: ["Applicant", "អ្នកស្នើសុំ"],
    transaction: ["Transaction", "លេខប្រតិបត្តិការ"],
    amount: ["Paid Amount", "បានបង់ប្រាក់ចំនួន"],
    applicant_type: ["Applicant Type", "ប្រភេទអ្នកស្នើសុំ"],
    hpc_resource: ["HPC Resource Allocation", "ការផ្តល់ជូនអង្គគណនាពពកកម្រឹតខ្អស់"],
    legal_person: ["Legal Person", "នីតិបុគ្គល"],
    physical_person: ["Physical Person", "រូបវន្តបុគ្គល"],
    applicant_legal_id: ["Business Registration ID", "លេខចុះបញ្ជីពាណិជ្ចកម្ម"],
    applicant_physical_id: ["ID Number / Passport", "លេខអត្តសញ្ញាណប័ណ្ណ ឬលិខិតឆ្លងដែន"],
    applicant_legal_name_km: ["Company Name in Khmer", "ឈ្មោះក្រុមហ៊ុនជាភាសាខ្មែរ"],
    applicant_legal_name_en: ["Company Name in Latin", "ឈ្មោះក្រុមហ៊ុនជាភាសាឡាតាំង"],
    applicant_physical_name_km: ["Name in Khmer", "ឈ្មោះជាភាសាខ្មែរ"],
    applicant_physical_name_en: ["Name in Latin", "ឈ្មោះជាភាសាឡាតាំង"],

    receipt: ["Receipt", "បង្កាន់ដៃបង់ប្រាក់"],
    attachment: ["Attachments", "ឯកសារភ្ជាប់"],
    noDocument: ["No document available.", "មិនមានឯកសារ។"],
    notFound: ["The page you are looking for is not found !", "ទំព័រដែរអ្នកស្វែងរកមិនមានទេ!"],
    ago: [" ago", "មុន"],
    listMore: ["Show More", "ទាញយកបន្ថែម"],
    by: ["by", "ដោយ"],
    pending_applications: ["Pending Tasks", "រង់ចាំត្រួតពិនិត្យ"],
    ongoing_applications: ["Ongoing Tasks", "កំពុងដំណើរការ"],
    completed_applications: ["Finished Tasks", "បានបញ្ចប់ដំណើរការ"],
    manage_unit: ["Unit Management", "គ្រប់គ្រងអង្គភាព"],
    manage_user: ["User Management", "គ្រប់គ្រងអ្នកប្រើប្រាស់"],
    manage_flow: ["Flow Management", "គ្រប់គ្រងលំហូសេវា"],
    no_user: ["No User Available.", "មិនមានអ្នកប្រើប្រាស់"],
    user_and_unit: ["User and Unit", "អ្នកប្រើប្រាស់ និងអង្គភាព"],
    contact: ["Contact", "ទំនាក់ទំនង"],
    permission: ["Permission", "សិទ្ធប្រើប្រាស់"],
    unit_flow: ["Unit Flow", "លំហូអង្គភាព"],
    no_flow: ["No Public Service Flow.", "មិនមានលំហូសេវាសាធារណៈ"],
    single_id: ["MISTI Single ID", "លេខអត្តសញ្ញាណ MISTI Single ID"],
    user_name: ["User Name", "ឈ្មោះគណនី"],
    phone_number: ["Phone Number", "លេខទូរស័ព្ទ"],
    email: ["Email", "អ៊ីម៉ែល"],
    unit: ["Unit", "អង្គភាព"],
    new_user: ["Create New User", "បង្កើតអ្នកប្រើប្រាស់ថ្មី"],
    permission_setting: ["User Permission Settings", "សិទ្ធក្នុងការប្រើប្រាស់ប្រព័ន្ធ"],
    create_user: ["Create User", "បង្កើតគណនី"],
    edit_user: ["Edit User", "កែប្រែគណនី"],
    unit_name: ["Unit Name", "ឈ្មោះអង្គភាព"],
    unit_user: ["Users", "អ្នកប្រើប្រាស់"],
    people: ["user(s)", "នាក់"],
    no_unit: ["No Units.", "មិនមានអង្គភាព"],
    new_unit: ["Create New Unit", "បង្កើតអង្គភាពថ្មី"],
    no_pending: ["You don't have any pending task.", "មិនមានឯកសាររង់ចាំត្រួតពិនិត្យ"],
    code_and_project: ["Code and Project", "លេខកូដ និងគម្រោង"],
    reviewing: ["Reviewing", "ការត្រួតពិនិត្យ"],
    status_and_created: ["Status and Date", "ស្ថានភាព និងថ្ងៃដាក់ពាក្យដំបូង"],
    waiting: ["Waiting ", "រង់ចាំ"],
    search_keyword: ["Search by keywords", "ស្វែងរកតាមរយៈពាក្យ"],
    reviewing_unit: ["Reviewing Unit", "អង្គភាពកំពុងត្រួតពិនិត្យ"],
    no_ongoing: ["No Ongoing Tasks.", "មិនមានពាក្យកំពុងដំណើរការទេ"],
    no_completed: ["No Completed Tasks.", "មិនមានពាក្យស្នើសុំបានបញ្ចប់ដំណើរការទេ។"],
    reviewing_comment: ["Reviewing Comments", "មតិយោបល់ក្នុងការត្រួតពិនិត្យ"],
    comment_to_applicant: ["Comment to Applicant", "មតិយោបល់ទៅកាន់អ្នកស្នើសុំ"],
    internal_note: ["Internal Note", "ការកំណត់ចំណាំផ្សេងៗផ្ទៃក្នុង"],
    internal_comment: ["Internal Comment", "មតិយោបល់ផ្ទៃក្នុង"],
    save: ["Save", "រក្សាទុក"],
    preview: ["Preview", "បង្ហាញ"],
    edit_certificate: ["Edit Certificate", "កែប្រែព័ត៌មានប្រកាស/វិញ្ញាបនបត្រ/អាជ្ញាប័ណ្ណ"],
    workspace: ["Workspace", "ប្រតិបត្តិការងារ"],
    certificate_setting: ["Certificate Settings", "ការកំណត់ការចេញប្រកាស/វិញ្ញាបនបត្រ/អាជ្ញាប័ណ្ណ"],
    application_form: ["HPC Request Form", "ពាក្យស្នើសុំអង្គគណនាពពកកម្រឹតខ្អស់"],
    backward: ["BACKWARD", "បញ្ជូនចុះក្រោម"],
    forward: ["FORWARD", "បញ្ជូនឡើងបន្ត"],
    return_back: ["RETURN", "បញ្ជូនត្រឡប់កែប្រែ"],
    reject: ["REJECT & FINISH", "បដិសេដ និងបញ្ចប់ការផ្តល់សេវា"],
    approve: ["APPROVE & FORWARD", "អនុម័ត និងបញ្ជូនបន្ត"],
    stamp: ["STAMP & FORWARD", "បោះត្រា និងបញ្ជូនបន្ត"],
    assign_number: ["ASSIGN NUMBER & FINISH", "ចុះលេខ និងផ្តល់ជូនសេវា"],
    comment: ["Comment", "មតិយោបល់"],
    receive_unit: ["Receiving Unit", "អង្គភាពទទួលបន្ត"],
    edit_update: ["Edit & Update", "កែប្រែព័ត៌មាន និងធ្វើបច្ចុប្បន្នភាព"],
    create_certificate: ["Create Certificate", "បង្កើតប្រកាស/វិញ្ញាបនបត្រ/អាជ្ញាប័ណ្ណ"],
    reference: ["Reference Number", "ចុះលេខចេញ"],
    reference_date: ["Reference Date", "ចុះថ្ងៃចេញ"],
    create_unit: ["Create Unit", "បង្កើតអង្គភាព"],
    edit_unit: ["Edit Unit", "កែប្រែអង្គភាព"],
    please_create_certificate: ["Please create certificate!", "សូមធ្វើការបង្កើតប្រកាស/វិញ្ញាបនបត្រ/អាជ្ញាប័ណ្ណ។"],
    assign_hpc: ["Assign HPC", "បញ្ចូលអង្គគណនា"],
    complete: ["Complete HPC Request", "បញ្ចប់ពាក្យស្នើសុំអង្គគណនាពពកកម្រឹតខ្អស់"],
    add: ["Add", "បញ្ចូល"],
    test: ["aaaaaaaa", "aaaaaaaaa"],
    test: ["aaaaaaaa", "aaaaaaaaa"],
    test: ["aaaaaaaa", "aaaaaaaaa"],
    test: ["aaaaaaaa", "aaaaaaaaa"],
    test: ["aaaaaaaa", "aaaaaaaaa"],
    test: ["aaaaaaaa", "aaaaaaaaa"],
    test: ["aaaaaaaa", "aaaaaaaaa"],
    test: ["aaaaaaaa", "aaaaaaaaa"],
    test: ["aaaaaaaa", "aaaaaaaaa"],
    test: ["aaaaaaaa", "aaaaaaaaa"],
    test: ["aaaaaaaa", "aaaaaaaaa"],
    test: ["aaaaaaaa", "aaaaaaaaa"],
    test: ["aaaaaaaa", "aaaaaaaaa"],
    test: ["aaaaaaaa", "aaaaaaaaa"],
    test: ["aaaaaaaa", "aaaaaaaaa"],
    test: ["aaaaaaaa", "aaaaaaaaa"],
    test: ["aaaaaaaa", "aaaaaaaaa"],
    test: ["aaaaaaaa", "aaaaaaaaa"],
    test: ["aaaaaaaa", "aaaaaaaaa"],
}





// WEBPACK FOOTER //
// ./src/config/locale.js